import {useEffect} from "react";
import styled from "styled-components";
import {scheduleApi} from "../../api/schedule-api";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {scheduleState, setSchedulePageAction,} from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import {Assign} from "../../types/schedule/assign";
import {LineMatchStatus} from "../../types/schedule/line-match-status";
import {PageController} from "../paging/PageController";
import {SearchSchedulesInPeriodTable} from "../table/SearchSchedulesInPeriodTable";

interface Props {
    selectLineMatchStatus: string[];
    dateToWork: string;
}

export const ScheduleLineDashboard: React.FC<Props> = (
    {
        selectLineMatchStatus,
        dateToWork,
    }
) => {
    const dispatch = useAppDispatch();
    const {schedulePage} = useAppSelector(scheduleState);

    const handleChangePage = (selectedItem: { selected: number }) => {
        const page = selectedItem.selected;
        displaySchedules(page);
    };

    const displaySchedules = async (page: number = 0) => {
        try {
            const response = await scheduleApi.search({
                page: schedulePage.page,
                fromDate: dateToWork,
                toDate: dateToWork,
                assignOption: getAssignOption(),
            });
            dispatch(
                setSchedulePageAction({
                    schedulePageDto: response.data,
                })
            );
        } catch (error) {
            console.log(error);
        }
    };

    const getAssignOption = () => {
        if (selectLineMatchStatus.length === 2) return Assign.All;

        if (selectLineMatchStatus[0] === LineMatchStatus.beforeMatched) {
            return Assign.Unassigned;
        }

        if (selectLineMatchStatus[0] === LineMatchStatus.afterMatched) {
            return Assign.Assigned;
        }

        return Assign.All;
    };

    useEffect(() => {
        displaySchedules();
    }, [selectLineMatchStatus, dateToWork]);

    return (
        <ScheduleLineDashboardContainer>
            <NotificationHeader>
                프로님을 배정할 스케줄을 선택하세요
            </NotificationHeader>
            <SearchSchedulesInPeriodTable/>
            <PageController basePage={schedulePage} onPageChange={handleChangePage}/>
        </ScheduleLineDashboardContainer>
    );
};

const ScheduleLineDashboardContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${theme.palette.primitives.gray50};
`;

const NotificationHeader = styled.div`
  padding: 16px 0 16px 41px;
  width: 100%;
  background-color: ${theme.palette.primitives.yellow100};
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
`;
